import { FC, useEffect } from 'react';
import { create } from 'zustand';
import { AuthenticateGithubDialog } from 'client/components/GitHub/AuthenticateGithubDialog';
import { useGitHubAccess } from 'client/components/GitHub/useGitHubAccess';

export interface GitHubState {
  user: {
    githubUsername: string;
    githubAvatarURL: string;
  } | null;
  reload: () => void;
  isDialogOpen: boolean;
  isAuthenticated: boolean;
  isLoading: boolean;
}

const initialState: GitHubState = {
  user: null,
  reload: () => {},
  isDialogOpen: false,
  isAuthenticated: false,
  isLoading: true,
};

export const useGitHubState = create(() => initialState);

export const GitHubProvider: FC = () => {
  const { user, reload, isUnauthenticated, isLoading } = useGitHubAccess({ scope: ['user'] });

  useEffect(() => useGitHubState.setState({ reload }), [reload]);

  useEffect(() => {
    const isAuthenticated = !!user && !isUnauthenticated;
    useGitHubState.setState({ user, isAuthenticated, isLoading });
  }, [user, isUnauthenticated, isLoading]);

  return <AuthenticateGithubDialog />;
};
